export enum CredentialType {
    password = 'password',
    twoFactor = 'twoFactor',
}
